import React, { useState, useEffect } from "react";
import img from "../../Assets/contactus.png";
import UsaImg from '../../Assets/UsaImg.png'
import { sendContactFormEmail } from '../../utils/emailService';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";

const EIGHTEEN_WHEELER_ACCIDENT= '18-wheeler-accident';


const ContactUs = () => {
    const [pingUrl, setPingUrl] = useState("");
    const [certId, setCertId] = useState("");
    const [tokenUrl, setTokenUrl] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    category: "",
    concern: "",
    caseHistory: "",
  });
// Function to get the initial landing URL
let initialLandingUrl = null;
 
const getSourceUrl = () => {
  if (typeof window === "undefined") return "Unknown";
 
  // If we haven't stored the initial URL yet, store it
  if (!initialLandingUrl) {
    initialLandingUrl = window.location.href;
  }
 
  return initialLandingUrl;
};
 
// Function to get IP address
const getIPAddress = async () => {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error("Failed to get IP address:", error);
    return "IP address not available";
  }
};


// Function to get Form Details
const getFormDetails = () => {
  const path = window.location.pathname; 

  if (path === "/" || path === "") {
    return { formname: "Home Form" };
  }

  const pageKey = path.replace("/", ""); 

  const readable = pageKey
    .replace(/Main$/i, "") 
    .replace(/([a-z])([A-Z])/g, "$1 $2") 
    .trim();

  return { formname: `${readable} Form` };
};
  const [errors, setErrors] = useState({
    phoneNumber: "",
    email: "",
  });

  const [isMobile, setIsMobile] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  useEffect(() => {
    let observer;
    let timeoutId;

    const initializeTrustedForm = () => {
      // Check for initial values
      const checkInitialValues = () => {
        const certUrlField = document.querySelector(
          'input[name="xxTrustedFormCertUrl"]'
        );
        const tokenField = document.querySelector(
          'input[name="xxTrustedFormCertToken"]'
        );
        const pingUrlField = document.querySelector(
          'input[name="xxTrustedFormPingUrl"]'
        );

        if (certUrlField?.value) {
          setCertId(certUrlField.value);
          console.log("Initial cert_id:", certUrlField.value);
        }
        if (tokenField?.value) {
          setTokenUrl(tokenField.value);
          console.log("Initial tokenUrl:", tokenField.value);
        }
        if (pingUrlField?.value) {
          setPingUrl(pingUrlField.value);
          console.log("Initial pingUrl:", pingUrlField.value);
        }
      };

      // Set up mutation observer
      observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "value"
          ) {
            const fieldName = mutation.target.name;

            // Extract values from all TrustedForm fields
            const certUrlField = document.querySelector(
              'input[name="xxTrustedFormCertUrl"]'
            );
            const tokenField = document.querySelector(
              'input[name="xxTrustedFormCertToken"]'
            );
            const pingUrlField = document.querySelector(
              'input[name="xxTrustedFormPingUrl"]'
            );

            const certUrlValue = certUrlField?.value || "";
            const tokenValue = tokenField?.value || "";
            const pingUrlValue = pingUrlField?.value || "";

            // Update state with the correct values
            setCertId(certUrlValue);
            setPingUrl(pingUrlValue);
            setTokenUrl(tokenValue);

            // console.log("TrustedForm field update:", {
            //   fieldName,
            //   certId: certUrlValue,
            //   pingUrl: pingUrlValue,
            //   tokenUrl: tokenValue
            // });

            // Fetch cert data if we have a cert URL and it's the cert field that changed
            if (certUrlValue && fieldName === "xxTrustedFormCertUrl") {
              fetchCertData(certUrlValue);
            }
          }
        });
      });

      // Observe all TrustedForm fields for changes
      const fieldsToObserve = [
        "xxTrustedFormCertUrl",
        "xxTrustedFormCertToken",
        "xxTrustedFormPingUrl",
      ];

      fieldsToObserve.forEach((fieldName) => {
        const field = document.querySelector(`input[name="${fieldName}"]`);
        if (field) {
          observer.observe(field, { attributes: true });
          // console.log(`Observing field: ${fieldName}`);
        }
      });

      // Check for initial values after a delay to allow TrustedForm to load
      timeoutId = setTimeout(checkInitialValues, 1000);
    };

    // Initialize TrustedForm monitoring
    initializeTrustedForm();

    return () => {
      if (observer) {
        observer.disconnect();
      }
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  const fetchCertData = async (certUrl) => {
    try {
      const response = await fetch(certUrl);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      console.log("TrustedForm Cert Data:", data);
      return data;
    } catch (error) {
      console.error("Error fetching TrustedForm cert:", error);
      return null;
    }
  };
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const validatePhoneNumber = (phoneNumber) => {
    const phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    return phoneRegex.test(phoneNumber);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear error when field is being edited
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ""
      }));
    }

    // Validate on change for immediate feedback
    if (name === "phoneNumber" && value && !validatePhoneNumber(value)) {
      setErrors(prev => ({
        ...prev,
        phoneNumber: "Please enter a valid US phone number (e.g., 123-456-7890)"
      }));
    }

    if (name === "email" && value && !validateEmail(value)) {
      setErrors(prev => ({
        ...prev,
        email: "Please enter a valid email address"
      }));
    }
  };

  const handleSubmit = async(e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Validate all fields before submission
    const newErrors = {
      phoneNumber: formData.phoneNumber && !validatePhoneNumber(formData.phoneNumber)
        ? "Please enter a valid US phone number (e.g., 123-456-7890)"
        : "",
      email: formData.email && !validateEmail(formData.email)
        ? "Please enter a valid email address"
        : ""
    };

    setErrors(newErrors);

    // Check if there are any errors
    if (Object.values(newErrors).some(error => error)) {
      setIsSubmitting(false);
      return; // Don't submit if there are errors
    }

    console.log("Form submitted:", formData);
   await fetch('https://crm-internal-backend-ayb9fqawg8b6bjen.canadacentral-01.azurewebsites.net/api/submitformdata', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    countryName: 'Usa',
      brandName: 'Personal Injury',
      websiteName: 'Truck Accident Lawsuit expert',
    formname: getFormDetails().formname,
    vertical:  EIGHTEEN_WHEELER_ACCIDENT,
    data: {
    name: formData.name,
    email: formData.email,
    phone: formData.phoneNumber,
    category: formData.category,
    concern: formData.concern,
    caseHistory: formData.caseHistory,
    ipAddress: await getIPAddress(),
    trustedFormToken: certId,
    trustedFormPingUrl: pingUrl,
    trustedFormCertUrl: tokenUrl,
    submissionDate: new Date().toISOString(),
    pageSource: getSourceUrl(),
    additionalInfo: formData.details,
    agreeToPolicy: formData.agreeToPolicy ? 'Yes' : 'No'
  }
  })
});

const updatedFormData={
  ...formData,certId,pingUrl,tokenUrl,
}

    // Send email using EmailJS
    sendContactFormEmail(updatedFormData)
      .then(result => {
        if (result.success) {
          toast.success('Your contact form has been submitted successfully!');
          // Optionally reset form
          setFormData({
            name: "",
            phoneNumber: "",
            email: "",
            category: "",
            concern: "",
            caseHistory: "",
          });
        } else {
          toast.error('Failed to submit form. Please try again.');
        }
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const errorStyle = "text-red-500 text-sm mt-1 ml-3";

  if (isMobile) {
    return (
      <div className="w-full min-h-screen bg-[#f8f5ee] text-[#1b1818] font-nunito pt-50 p-4 relative overflow-hidden">
        <ToastContainer position="top-right" autoClose={5000} />
        <div className="relative pt-[80px] text-[42px] font-bricolage text-[#5d2446] mb-2 z-10">Contact Us</div>
        <p className="text-[18px] text-[#2c3c58] mb-6 z-10 relative">
          Feel free to contact us any time. We will get back to you as soon as we can.
        </p>

        {/* Background image */}
        <div
          className="absolute top-[280px] left-0 w-full h-[65vh] bg-top bg-no-repeat bg-cover z-0"
          style={{ backgroundImage: `url(${UsaImg})` }}
        />

        <form onSubmit={handleSubmit} className="bg-white p-4 rounded-3xl shadow-md text-[#999] mb-6 z-10 relative">
                          <input
                  type="hidden"
                  id="xxTrustedFormCertUrl"
                  name="xxTrustedFormCertUrl"
                  value={certId}
                />
                <input
                  type="hidden"
                  id="xxTrustedFormCertToken"
                  name="xxTrustedFormCertToken"
                  value={tokenUrl}
                />
                <input
                  type="hidden"
                  id="xxTrustedFormPingUrl"
                  name="xxTrustedFormPingUrl"
                  value={pingUrl}
                />

          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full mb-4 p-3 rounded-full border border-[#8d8e9e] text-[#1b1818] font-poppins focus:bg-[#121D2A] focus:text-[#d8d8d8]"
            placeholder="Name"
          />

          <div className="mb-4">
            <input
              type="tel"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              className={`w-full p-3 rounded-full border ${errors.phoneNumber ? "border-red-500" : "border-[#8d8e9e]"} focus:bg-[#121D2A] focus:text-[#d8d8d8]`}
              placeholder="Phone Number"
            />
            {errors.phoneNumber && <p className={errorStyle}>{errors.phoneNumber}</p>}
          </div>

          <div className="mb-4">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className={`w-full p-3 rounded-full border ${errors.email ? "border-red-500" : "border-[#8d8e9e]"} focus:bg-[#121D2A] focus:text-[#d8d8d8]`}
              placeholder="E-Mail Id"
            />
            {errors.email && <p className={errorStyle}>{errors.email}</p>}
          </div>

          <select
            name="category"
            value={formData.category}
            onChange={handleChange}
            className="w-full mb-4 p-3 rounded-full border border-[#8d8e9e] focus:bg-[#121D2A] focus:text-[#d8d8d8]"
          >
            <option value="">Select the category</option>
            <option value="general">General Inquiry</option>
            <option value="support">Support</option>
            <option value="feedback">Feedback</option>
            <option value="18-wheeler-crash">18-Wheeler Crash</option>
          </select>

          <select
            name="concern"
            value={formData.concern}
            onChange={handleChange}
            className="w-full mb-4 p-3 rounded-full border border-[#8d8e9e] focus:bg-[#121D2A] focus:text-[#d8d8d8]"
          >
            <option value="">Select Your Concern</option>
            <option value="technical">Technical Issue</option>
            <option value="billing">Billing</option>
            <option value="other">Other</option>
          </select>

          <textarea
            name="caseHistory"
            value={formData.caseHistory}
            onChange={handleChange}
            className="w-full mb-6 p-3 rounded-2xl border border-[#8d8e9e] h-32 resize-none focus:bg-[#121D2A] focus:text-[#d8d8d8]"
            placeholder="Brief Case History"
          />

          <button
            type="submit"
            disabled={isSubmitting}
            className={`w-full bg-[#f2c438] hover:bg-[#e6b82e] text-black font-bold py-3 rounded-xl transition-colors duration-300 flex items-center justify-center ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`}
          >
            {isSubmitting ? (
              <>
                <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                SUBMITTING...
              </>
            ) : (
              'CONTINUE'
            )}
          </button>
        </form>
      </div>
    );
  }

  return (
    <div className="w-full relative bg-[#f8f5ee] h-[1300px] overflow-hidden text-center text-[24px] text-[#1b1818] font-nunito">
      <ToastContainer position="top-right" autoClose={5000} />
      <div className="absolute top-[183px] left-[95px] text-[82px] font-bricolage text-[#5d2446] text-left z-10">
        Contact Us
      </div>
      <div className="absolute top-[293px] left-[95px] text-[28px] text-[#2c3c58] text-left inline-block w-[533px] z-10">
        Feel free to contact us any time. We will get back to you as soon as we can.
      </div>

      <div
        className="absolute top-[480px] left-0 w-[100vw] h-[820px] overflow-auto bg-top bg-no-repeat bg-cover z-0"
        style={{ backgroundImage: `url(${UsaImg})` }}
      >
        <div className="absolute top-0 left-[-241px] w-[800px] h-[600px]" />
      </div>

      <form
        onSubmit={handleSubmit}
        className="absolute top-[329px] left-[595.81px] shadow-[0_5px_20px_rgba(0,0,0,0.25)] rounded-[80px] bg-[#f8f5ee] w-[789.9px] h-[780px] overflow-hidden text-left text-[23.7px] text-[#999] z-20"
      >
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          className="absolute top-[50.5px] left-[39.16px] rounded-[35.12px] border border-[#8d8e9e] box-border w-[711.2px] px-[33.9px] py-[10px] text-[#1b1818] font-poppins focus:bg-[#121D2A] focus:text-[#d8d8d8] transition-colors duration-300"
          placeholder="Name"
        />

        <div className="absolute top-[141.66px] left-[39.16px] w-[706.2px]">
          <input
            type="tel"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            className={`rounded-[35.12px] border ${errors.phoneNumber ? "border-red-500" : "border-[#8d8e9e]"} box-border w-full px-[33.9px] py-[10px] focus:bg-[#121D2A] focus:text-[#d8d8d8] transition-colors duration-300`}
            placeholder="Phone Number"
          />
          {errors.phoneNumber && (
            <p className="text-red-500 text-[16px] mt-1 ml-[34px]">{errors.phoneNumber}</p>
          )}
        </div>

        <div className="absolute top-[229.88px] left-[39.16px] w-[707.3px]">
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className={`rounded-[35.12px] border ${errors.email ? "border-red-500" : "border-[#8d8e9e]"} box-border w-full px-[34.5px] py-[11.1px] focus:bg-[#121D2A] focus:text-[#d8d8d8] transition-colors duration-300`}
            placeholder="E-Mail Id"
          />
          {errors.email && (
            <p className="text-red-500 text-[16px] mt-1 ml-[34px]">{errors.email}</p>
          )}
        </div>

        <select
          name="category"
          value={formData.category}
          onChange={handleChange}
          className="absolute top-[320.28px] left-[39.16px] rounded-[35.12px] border border-[#8d8e9e] box-border w-[707.3px] px-[34.5px] py-[11.1px] focus:bg-[#121D2A] focus:text-[#d8d8d8] transition-colors duration-300"
        >
          <option value="">Select your concern</option>
          <option value="18-wheeler-crash">18-Wheeler Crash</option>
          <option value="feedback">Other</option>
        </select>

        <textarea
          name="caseHistory"
          value={formData.caseHistory}
          onChange={handleChange}
          className="absolute top-[410.69px] left-[39.16px] rounded-[35.12px] border border-[#8d8e9e] box-border w-[707.3px] h-[183.8px] px-[34.53px] py-[11.13px] focus:bg-[#121D2A] focus:text-[#d8d8d8] transition-colors duration-300"
          placeholder="Brief Case History"
        />

        <button
          type="submit"
          disabled={isSubmitting}
          className={`absolute top-[680px] left-[39.16px] rounded-[35.12px] bg-[#f2c438] w-[711.2px] h-[67.3px] text-black font-montserrat font-semibold uppercase hover:bg-[#e6b82e] transition-colors duration-200 flex items-center justify-center ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`}
        >
          {isSubmitting ? (
            <>
              <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              SUBMITTING...
            </>
          ) : (
            'CONTINUE'
          )}
        </button>
      </form>
    </div>
  );
};

export default ContactUs;
